__webpack_require__.p = "https://support.jainam.in/";